export enum ItemType {
  Unknown = 0,
  Consumable,
  Equipment,
  Sellable,
  Key,
  Material,
  Module,
}

export enum EquipmentType {
  Unknown = 0,
  Head,
  Torso,
  Mainhand,
  Offhand,
  Waist,
  Legs,
  Feet,
  Ears,
  Neck,
  Wrists,
  Hands,
  Shoulders,
  Transport,
}

export enum EffectType {
  Unknown = 0,
  RestoreHealth,
  RestoreEnergy,
  RestoreSpirit,
  BuffHealth,
  BuffEnergy,
  BuffSpirit,
  DecreaseHealth,
  DecreaseEnergy,
  DecreaseSpirit,
  DebuffHealth,
  DebuffEnergy,
  DebuffSpirit,
  BuffDamagePercent,
  BuffArmourPercent,
  BuffCraftingSuccessPercent,
  AddCredits,
  RemoveCredits,
  AcceptMission,
  AddItem,
  AddSkill,
  AddCraftingSchematic,
  AddModuleSlot,
  RestoreHealthPercent,
  RestoreEnergyPercent,
  RestoreSpiritPercent,
  BuffHealthPercent,
  BuffEnergyPercent,
  BuffSpiritPercent,
  DebuffHealthPercent,
  DebuffEnergyPercent,
  DebuffSpiritPercent,
}

export enum SkillEffectType {
  Unknown = 0,
  Passive,
  AddToLearnedSkills,
}

export enum LocationType {
  Unknown = 0,
  Stats,
  Shop,
  Hospital,
  Workout,
  Job,
  Arena,
  Crafting,
  Skills,
  Gateway,
  Market,
}

export enum CombatType {
  Unknown = 0,
  Arena,
  Multiplayer,
}

export enum CombatEffectType {
  Unknown = 0,
  Block,
  Flex,
}

export enum CombatTurnType {
  Unknown = 0,
  Action,
  Passive,
}

export enum CombatStatus {
  Unknown = 0,
  Won,
  Lost,
  TimedOut,
  Tied,
}

export enum MissionType {
  Unknown = 0,
  Buy,
  Sell,
  Defeat,
  SendChatMessage,
  SendMail,
  LearnSkill,
  CraftItem,
  PerformJob,
  PerformWorkout,
  EquipItem,
  UnequipItem,
  EquipSkill,
  UnequipSkill,
  ConsumeItem,
  UseGateway,
  SendItem,
  RemoveItem,
  BuyHealing,
  HandInItem,
  Overdose,
  LearnSkillFailure,
  LearnSkillFailureAny,
  UnlearnSkill,
  UnlearnSkillAny,
  AddModuleSlot,
  InstallModule,
  UninstallModule,
  CompleteMission,
  LearnCraftingSchematic,
  UpdateBiography,
  LearnTrait,
  LearnTraitAny,
  ListMarketItem,
  BuyMarketItem,
  FulfillMarketOrder,
  CancelMarketOrder,
  SendCorporationChatMessage,
}

export enum MissionRewardType {
  Unknown = 0,
  Credits,
  Item,
  Mission,
  Skill,
  Experience,
  RestoreHealth,
  RestoreEnergy,
  RestoreSpirit,
  Influence,
}

export enum ChatMessageType {
  Default = 0,
  Announcement,
  System,
}

export enum ChatChannelType {
  Public,
  Private,
  Corporation,
  Party,
}

export enum PopupNotificationType {
  Unknown = 0,
  Success,
  Error,
  Info,
  Warning,
}

export enum DuelHandshake {
  Unknown = 0,
  Offer,
  Accept,
  Decline,
  Timeout,
}

export enum NpcDifficulty {
  Normal,
  Elite,
  Veteran,
  Master,
  Champion,
  Legend,
  Mythic,
  Divine,
}

export enum PartyMembership {
  Invited = 'invited',
  Member = 'member',
  Leader = 'leader',
}

export enum UserStatus {
  Unknown = 0,
  Online,
  Away,
  Offline,
  InCombat,
}

export enum CorporationPermission {
  AddItem = 1,
  RemoveItem = 2,
  ManageLowerRanks = 4,
  SpendInfluence = 8,
  EditDescriptions = 16,
  EditRanks = 32,
}

export enum ChatCommandStateRequirement {
  InParty = 'inParty',
  NotInParty = '!inParty',
  IsPartyLeader = 'isPartyLeader',
  IsNotPartyLeader = '!isPartyLeader',
  PartyHasNoMembers = 'partyHasNoMembers',
  PartyHasMembers = '!partyHasNoMembers',
  PartyHasMaxMembers = 'partyHasMaxMembers',
  PartyDoesNotHaveMaxMembers = '!partyHasMaxMembers',
  PartyIsNotInCombat = 'partyIsNotInCombat',
  PartyIsInCombat = '!partyIsNotInCombat',
  IsPartyInvitee = 'isPartyInvitee',
  IsNotPartyInvitee = '!isPartyInvitee',
  IsPartyMember = 'isPartyMember',
  IsNotPartyMember = '!isPartyMember',
  InCorporation = 'inCorporation',
  NotInCorporation = '!inCorporation',
  IsCorporationRequestAccepter = 'isCorporationRequestAccepter',
  IsNotCorporationRequestAccepter = '!isCorporationRequestAccepter',
  IsCorporationRequestRejecter = 'isCorporationRequestRejecter',
  IsNotCorporationRequestRejecter = '!isCorporationRequestRejecter',
  IsCorporationJoinRequestor = 'isCorporationJoinRequestor',
  IsNotCorporationJoinRequestor = '!isCorporationJoinRequestor',
  IsCorporationKicker = 'isCorporationKicker',
  IsNotCorporationKicker = '!isCorporationKicker',
}

export enum GatewayRequirementType {
  Item,
  Equipment,
}

export enum ArenaRequirementType {
  Item = 'item',
  Equipment = 'equipment',
  Skill = 'skill',
  Trait = 'trait',
  Level = 'level',
}

export enum RankPermissions {
  None = 0, // This is a special value that is used to represent no permissions, used when creating a new rank
  AcceptJoinRequests = 1,
  RemoveMembers = 2,
  SetMemberRank = 4,
  ChangeRankPermissions = 8,
  DistributeItem = 16,
  DonateItem = 32,
  ChangeRankPriority = 64,
  ChangeRankName = 128,
  CreateRank = 256,
  RenameRank = 512,
  RemoveRank = 1024,
  SetPublicDescription = 2048,
  SetPrivateDescription = 4096,
  SpendInfluence = 8192,
  RejectJoinRequests = 16_384,
  SetNewMembersRank = 32_768,
  ManageMissions = 65_536,
}

export enum CorporationEventType {
  AcceptedJoinRequest = 1,
  RemovedMember,
  SetMemberRank,
  ChangedRankPermissions,
  DistributedItem,
  DonatedItem,
  ChangedRankPriority,
  CreatedRank,
  RenamedRank,
  RemovedRank,
  SetPublicDescription,
  SetPrivateDescription,
  SpentInfluence,
  RejectedJoinRequest,
  SetNewMembersRank,
  Left,
  CreatedCorporation,
  CorporationMissionCompleted,
}

export enum CorporationShopItemId {
  MembershipLimitIncrease = 0,
  InventoryLimitIncrease,
  TempBuffDamage,
  TempBuffArmour,
  TempBuffCraftingSuccess,
  TempBuffEnergyCap,
  TempBuffSpiritCap,
  GrantEnergyPack,
  GrantSpiritPack,
  PermBuffDamage,
  PermBuffArmour,
  PermBuffCraftingSuccess,
}

export enum CorporationShopItemType {
  MembershipIncrease = 0,
  InventoryIncrease,
  TemporaryBuff,
  PermanentBuff,
  GrantItem,
}

export enum CorporationShopTemporaryBuffType {
  DamagePercent = 0,
  ArmourPercent,
  CraftingSuccessPercent,
  EnergyCap,
  SpiritCap,
}

export enum CorporationShopPermanentBuffType {
  PermanentDamagePercent = 0,
  PermanentArmourPercent,
  PermanentCraftingSuccessPercent,
}

export enum UserEventType {
  Login = 1,
  Logout,
  CombatDuelOfferSent,
  CombatDuelOfferReceived,
  MissionAccepted,
  MissionCompleted,
  ItemBought,
  ItemSold,
  ItemEquipped,
  ItemUnequipped,
  CorporationCreated,
  CorporationJoined,
  CorporationLeft,
  CorporationDisbanded,
  CorporationJoinRequestSent,
  CorporationJoinRequestAccepted,
  CorporationJoinRequestDeclined,
  MailSent,
  MailReceived,
  ItemSent,
  ItemReceived,
  ItemRemoved,
  ItemConsumed,
  ItemCrafted,
  MarketOrderPlaced,
  MarketOrderCompleted,
  MarketOrderCancelled,
  UseGateway,
  UpdateBiography,
  ProfileCommentPosted,
  ProfileCommentDeleted,
  ProfileCommentEdited,
  BugReportSubmitted,
  APIKeyCreated,
  APIKeyRevoked,
  AccountLinkAdded,
  AccountLinkRemoved,
  PartyCreated,
  PartyDisbanded,
  PartyInviteSent,
  PartyInviteReceived,
  PartyInviteAccepted,
  PartyInviteDeclined,
  PartyInviteCancelled,
  PartyLeft,
  PartyKickedMember,
  PerformJob,
}

export enum AutoTargetOnCombatEvent {
  FirstEnemy = 0,
  FirstCombatant,
  Self,
  NoTarget,
}

export enum MarketOrderType {
  Buy = 0,
  Sell,
}

export enum MarketOrderStatus {
  Listed = 0,
  Sold,
  Delisted,
}

export enum NameAvailability {
  Available = 0,
  Unavailable,
  Forbidden,
}
